module.exports = __webpack_public_path__ + "media/images/locations/spain-df4416c0c7bc5b295fe49af0fc3801f1.jpg";